import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { useParams } from 'react-router';

import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Paper, Tab, Tabs } from '@mui/material';

import moment from 'moment';

import { TabPanel, TabProps } from '../../../helpers/TabPanel';

import { openSnackbar } from '../../../store/slices/SnackbarSlice';

import { DialogActionsStyle, DialogContentStyle } from '../../../styles/DialogStyle';

import { Layout } from '../../../components/Layout';
import { InfoField } from '../../../components/InfoField';
import { BoxProcesoCancelado } from '../../../components/BoxProcesoCancelado';
import { BoxProcesoTerminado } from '../../../components/BoxProcesoTerminado';
import { BoxHeaderInformacion } from '../../../components/BoxHeaderInformacion';
import { BoxProcesoNoEncontrado } from '../../../components/BoxProcesoNoEncontrado';
import { BoxInformacionExpediente } from '../../../components/BoxInformacionExpediente';
import { CircularProgressIndicator } from '../../../components/CircularProgressIndicator';

import { ActualizarEstatusSentenciaPublica, DetalleSentenciaPublica } from '../../../connections/sentencia/SentenciaPublicaConnection';

import { defaultSentenciaPublica, SentenciaPublicaProps } from '../../../interfaces/sentencia/SentenciaPublicaInterface';

export const VisualizarSentenciaPublicaPage = () => {

    const dispatch = useDispatch();

    const { Id } = useParams();

    const [value, setValue] = useState( 0 );

    const [sentenciaPublica, setSentenciaPublica] = useState<SentenciaPublicaProps>( defaultSentenciaPublica )

    const [loading, setLoading] = useState( true );
    const [loadingFinalizar, setLoadingFinalizar] = useState( false );

    const [procesoTerminado, setProcesoTerminado] = useState( false );
    const [procesoCancelado, setProcesoCancelado] = useState( false );
    const [procesoNoEncontrado, setProcesoNoEncontrado] = useState( false );
    const [mensajeFinalizacion, setMensajeFinalizacion] = useState( '' );
    const [mensajeAsignacion, setMensajeAsignacion] = useState( '' );

    const [openDialogConfirmacionFinalizar, setOpenDialogConfirmacionFinalizar] = useState( false );

    const handleChange = ( _: React.SyntheticEvent, newValue: number ) => setValue( newValue )

    const handleFinalizar = async () => {

        setLoadingFinalizar( true );

        await ActualizarEstatusSentenciaPublica({ idSentenciaPublica: Id ?? '', idEstatus: 3, observaciones: '' }).then(resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    setMensajeFinalizacion('No se tienen actividades pendientes para este trámite');
                    setProcesoTerminado( true );
                    setLoadingFinalizar( false );

                }
                else {

                    dispatch(openSnackbar({ message: message, variant: 'error' }));
                    setLoadingFinalizar( false );

                }

            }, 700);

        });

    }

    useEffect(() => {

        setLoading( true );

        async function Obtener() {

            await DetalleSentenciaPublica( Id ?? '' ).then(resp => {

                setTimeout(() => {

                    const { success } = resp;

                    if ( success ) {

                        setSentenciaPublica( resp );

                        if ( resp.idEstatus === 3 ) {
                            setMensajeFinalizacion('No se tienen actividades pendientes para este trámite');
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.idEstatus === 4 ) {
                            setProcesoCancelado( true );
                            setLoading( false );
                        }
                        else if ( !resp.asignadoMismoUsuario ) {
                            setMensajeAsignacion(`La siguiente actividad se asignó a ${ resp.nombreUsuarioAsignado }`);
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus !== 42 ) {
                            setMensajeAsignacion('La siguiente actividad se encuentra en tu bandeja');
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus === 42 ) {
                            setLoading( false );
                        }
                    }
                    else {

                        setProcesoNoEncontrado( true );
                        setLoading( false );

                    }

                }, 700);

            });

        }

        if ( Id ) {

            Obtener();

        }

    }, [ Id ])

    return (
        <Layout breadcrumbs={ [{ text: 'Sentencia pública' }, { text: 'Visualizar sentencia pública' }] } backgroundPaper={ ( procesoTerminado || procesoCancelado || procesoNoEncontrado ) }>

            {
                ( procesoTerminado || procesoCancelado || procesoNoEncontrado )
                ?
                    procesoNoEncontrado
                    ?
                        <BoxProcesoNoEncontrado />
                    :
                        procesoCancelado
                        ?
                            <BoxProcesoCancelado />
                        :
                            <BoxProcesoTerminado message={ mensajeFinalizacion } messageAssing={ mensajeAsignacion } processEnd={ sentenciaPublica.idEstatus === 3 } />
                    :
                        loading
                        ?
                            <Box component={ Paper } height={ '70vh' } textAlign={ 'center' } alignContent={ 'center' } alignItems={ 'center' }>
                                <CircularProgressIndicator />
                            </Box>
                        :
                            <>

                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

                                    <Tabs value={ value } onChange={ handleChange }>

                                        <Tab label='Sentencia pública' {...TabProps(0)} />
                                        <Tab label="Información del expediente" {...TabProps(1)} />

                                    </Tabs>

                                </Box>

                                <TabPanel value={ value } index={ 0 }>

                                    <Box p={ 4 } component={ Paper }>

                                        <BoxHeaderInformacion
                                            numeroSeguimiento={ `GSEP-${ sentenciaPublica.idSentenciaPublica }` }
                                            fecha={ sentenciaPublica.fecha ?? new Date() }
                                            juez={ sentenciaPublica.juez }
                                        />

                                        <Grid container spacing={ 3 } mt={ 2 }>

                                            <Grid size={{ md: 4, xs: 12 }}>

                                                <InfoField
                                                    chip
                                                    label="Número de Sentencia (Resolución)"
                                                    value={ sentenciaPublica.numeroSentencia }
                                                />

                                            </Grid>

                                            <Grid size={{ md: 4, xs: 12 }}>

                                                <InfoField
                                                    chip
                                                    label="Tipo de Sentencia"
                                                    value={ `Sentencia ${ sentenciaPublica.tipoSentencia }` }
                                                />

                                            </Grid>

                                            <Grid size={{ md: 4, xs: 12 }}>

                                                <InfoField
                                                    chip
                                                    label="Fecha de Sentencia"
                                                    value={ sentenciaPublica.fechaSentencia ? moment( sentenciaPublica.fechaSentencia ).format('DD-MM-YYYY hh:mm a') : '' }
                                                />

                                            </Grid>

                                            <Grid size={{ md: 4, xs: 12 }}>

                                                <InfoField
                                                    chip
                                                    label="Sentido de sentencia"
                                                    value={ sentenciaPublica.sentidoSentencia }
                                                />

                                            </Grid>

                                            <Grid size={{ md: 4, xs: 12 }}>

                                                <InfoField
                                                    chip
                                                    label="¿Con perspectiva género?"
                                                    value={ sentenciaPublica.perspectivaGenero ? 'Si' : 'No' }
                                                />

                                            </Grid>

                                            <Grid size={{ md: 12, xs: 12 }}>

                                                <iframe
                                                    title='iframe-documento'
                                                    style={{ width: '100%', height: 800, borderRadius: 8 }}
                                                    src={ sentenciaPublica.documento }
                                                />

                                            </Grid>

                                            <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>

                                                <Grid container spacing={ 3 }>

                                                    <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'left' }}> </Grid>

                                                    <Grid size={{ md: 4, xs: 12 }} style={{ textAlign: 'center' }}>
                                                        <Button
                                                            fullWidth
                                                            color='primary'
                                                            variant='contained'
                                                            onClick={ () => setOpenDialogConfirmacionFinalizar( true ) }
                                                        >
                                                            Finalizar
                                                        </Button>
                                                    </Grid>

                                                    <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'right' }}> </Grid>

                                                </Grid>

                                            </Grid>

                                        </Grid>

                                    </Box>

                                </TabPanel>

                                <TabPanel value={ value } index={ 1 }>

                                    <BoxInformacionExpediente
                                        expediente={ sentenciaPublica.expediente }
                                    />

                                </TabPanel>

                                <Dialog
                                    fullWidth
                                    maxWidth='xs'
                                    open={ openDialogConfirmacionFinalizar }
                                    onClose={ () => { } }
                                >

                                    <DialogTitle>
                                        Confirmación
                                    </DialogTitle>

                                    <DialogContent sx={ DialogContentStyle }>

                                        <DialogContentText>
                                            ¿Desea finalizar la visualizacion de la sentencia?
                                        </DialogContentText>

                                    </DialogContent>

                                    <DialogActions sx={ DialogActionsStyle }>
                                        <Button color="secondary" disabled={ loadingFinalizar } onClick={ () => setOpenDialogConfirmacionFinalizar(false) }> Cancelar </Button>
                                        <Button loading={ loadingFinalizar } onClick={ () => handleFinalizar() } variant='contained' > Aceptar </Button>
                                    </DialogActions>

                                </Dialog>

                            </>
            }

        </Layout>
    )
}
